import { Trophy } from "@phosphor-icons/react";

/**
 * A/B variant tab switcher. Shows one button per variant with
 * trophy on winner and click count when > 0.
 */
export default function VariantSwitcher({
  variants,
  activeIdx,
  onSelect,
  perfMap,
  winnerId,
  platform,
  activePerf,
}) {
  return (
    <div className="mb-4">
      <div className="flex items-center justify-between mb-2">
        <div className="label-mono">A/B variants</div>
        {activePerf && activePerf.clicks > 0 && (
          <div className="font-mono text-[10px] text-zinc-400">
            {activePerf.clicks} click{activePerf.clicks !== 1 ? "s" : ""} ·{" "}
            {activePerf.share}%
          </div>
        )}
      </div>
      <div className="flex gap-1">
        {variants.map((v, i) => {
          const isWinner = v.id === winnerId;
          const clicks = perfMap.get(v.id)?.clicks || 0;
          const isActive = activeIdx === i;
          return (
            <button
              key={v.id}
              onClick={() => onSelect(i)}
              data-testid={`variant-${platform}-${i}`}
              className={`flex-1 px-3 py-2 border font-mono text-xs flex items-center justify-center gap-1.5 transition-colors ${
                isActive
                  ? "border-[#ccff00] bg-[#ccff00]/10 text-[#ccff00]"
                  : "border-white/10 text-zinc-400 hover:border-white/30 hover:text-white"
              }`}
            >
              <span>Variant {String.fromCharCode(65 + i)}</span>
              {isWinner && (
                <Trophy size={11} weight="fill" className="text-[#ccff00]" />
              )}
              {clicks > 0 && (
                <span className="text-[10px] text-zinc-500">· {clicks}</span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
